import { render, staticRenderFns } from "./PedidoList.vue?vue&type=template&id=1dbc4718&scoped=true"
import script from "./PedidoList.vue?vue&type=script&lang=js"
export * from "./PedidoList.vue?vue&type=script&lang=js"
import style0 from "./PedidoList.vue?vue&type=style&index=0&id=1dbc4718&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dbc4718",
  null
  
)

export default component.exports